import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { closeDialogs } from "../store/actions/ui";

const mapDispatchToProps = (dispatch: any) => ({
  closeDialogs: () => dispatch(closeDialogs())
})

const connector = connect(null, mapDispatchToProps);

const DialogOverlay = (props: ConnectedProps<typeof connector>) => (
  <div className="dialog-overlay" onClick={props.closeDialogs} style={{ display: "block" }}/>
)

export default connector(DialogOverlay);
